import { cn } from '@mint-lib/tw-utils';

export default function CommandShortcut({
  className,
  ...props
}: React.ComponentProps<'span'>) {
  return (
    <span
      data-slot="command-shortcut"
      className={cn(
        'flex h-5 w-fit min-w-5 items-center justify-center rounded-sm border border-border-secondary bg-ui-primary p-1 text-text-secondary',
        className,
      )}
      {...props}
    >
      <kbd className="shrink-0 text-[12px] leading-4.5">{props.children}</kbd>
    </span>
  );
}
